// extracted by mini-css-extract-plugin
module.exports = {"container":"e3afc254ff--container--yLESk","image":"e3afc254ff--image--ArzMO","description":"e3afc254ff--description--X59SZ","action":"e3afc254ff--action--TvGzV"};